import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import axios from 'axios';
import Drip from 'drip';
import { formatPositionItem } from '@/utils/';
import { isProd, ajaxPreUrl } from '@/config/';
import { API_GET_POSITION_DETAIL, API_GET_AD_DETAIL, API_GET_RECOMMEND_LIST, API_GET_SHOW_RECOMMEND_LIST, API_GET_PERFORMANCE_DETAIL, API_GET_TODAT_LIST, API_GET_ARTIST_LIST, API_GET_CONFIG, API_GET_CALENDAR_LIST, API_GET_BRAND_LIST, API_GET_BRAND_DETAIL } from '@/apis'; // 演出首页中通猫眼广告位idmap

var adPositionIdMap = {
  // 猫眼APP
  maoyan: {
    channelId: 1,
    positionIds: 1024
  },
  // 美团APP
  meituan: {
    channelId: 3,
    positionIds: 1030
  },
  // 点评APP
  dianping: {
    channelId: 6,
    positionIds: 1033
  },
  // 猫眼小程序
  wxapp_wallet: {
    channelId: 40002,
    positionIds: 1037
  },
  // 格瓦拉
  gewara: {
    channelId: 1,
    positionIds: 1218
  }
};
var _Drip$constant = Drip.constant,
    cityId = _Drip$constant.cityId,
    userId = _Drip$constant.userId,
    uuid = _Drip$constant.uuid,
    appName = _Drip$constant.uaInfo.appName;
var maoyanAd = adPositionIdMap[appName] || {
  channelId: 1,
  positionIds: 1024
}; // 深色： https://p1.meituan.net/myvideodistribute/0a01554e157f4d4f7c8824e3a37b55bb36545.png
// 浅色： https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png

function defaultPosterUrl() {
  var list = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return list.map(function (a) {
    a.posterUrl = a.posterUrl || 'https://p0.meituan.net/myvideodistribute/96c418c85d3735b8b54507ce7fbd17432789.png';
    return a;
  });
}
/**
 * 根据艺人的id，获取艺人列表
 * @param {Array} ipIds
 */


export function fetchArtistList() {
  return _fetchArtistList.apply(this, arguments);
}
/**
 * 获取首页今日必抢的列表
 */

function _fetchArtistList() {
  _fetchArtistList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Drip.getUuid();

          case 2:
            uuid = _context2.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2
            };
            return _context2.abrupt("return", axios.get(API_GET_ARTIST_LIST, {
              params: params
            }).then(function (_ref7) {
              var code = _ref7.code,
                  data = _ref7.data;
              if (code !== 200) return [];
              return data || [];
            }).catch(function () {
              return [];
            }));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchArtistList.apply(this, arguments);
}

export function fetchTodayList() {
  return _fetchTodayList.apply(this, arguments);
}
/**
 * 获取项目详情
 * @param {Array} pids 项目id数组
 */

function _fetchTodayList() {
  _fetchTodayList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Drip.getUuid();

          case 2:
            uuid = _context3.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2
            };
            return _context3.abrupt("return", axios.get("".concat(API_GET_TODAT_LIST), {
              params: params
            }).then(function (_ref8) {
              var code = _ref8.code,
                  data = _ref8.data;
              if (code !== 200) return [];
              return data || [];
            }).catch(function (e) {
              return [];
            }));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchTodayList.apply(this, arguments);
}

export function fetchPerformances() {
  var pids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  if (!pids || pids.length === 0) return [];
  return axios.get("".concat(API_GET_PERFORMANCE_DETAIL, "?pids=").concat(pids.join(','))).then(function (_ref) {
    var code = _ref.code,
        data = _ref.data;
    if (code !== 200) return [];
    return defaultPosterUrl(data || []);
  }).catch(function (e) {
    return [];
  });
}
/**
 * 获取推荐项目列表
 * @param {number} [pageNo=1] 页数
 */

export function fetchRecommendList() {
  var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20; // 性能优化，由于首屏数据不需要太多，修改为每页10条数据，

  return axios.get("".concat(API_GET_RECOMMEND_LIST, "/0;st=4;p=").concat(pageNo, ";s=").concat(pageSize, ";tft=0?pageSource=1")).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function () {
    return {
      code: 500,
      data: []
    };
  });
}
/**
 * 猫眼演出首页推荐项目列表
 * @param {number} [pageNo=1] 页数
 */

export function fetchShowRecommendList() {
  var pageNo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var pageSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
  var uuid = Drip.constant.uuid || '';
  return axios.get("".concat(API_GET_SHOW_RECOMMEND_LIST, "?pageNo=").concat(pageNo, "&pageSize=").concat(pageSize, "&pageSource=1&source=1")).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function () {
    return {
      code: 500,
      data: []
    };
  });
} // 获取为你推荐-折扣标签 ABtest

export var getABtest = /*#__PURE__*/function () {
  var _getABtest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var params, _uuid;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(Drip.UA.IS_MEITUAN || Drip.UA.IS_DIANPING)) {
              _context.next = 10;
              break;
            }

            params = {};
            _context.next = 4;
            return Drip.getUuid();

          case 4:
            _uuid = _context.sent;

            if (Drip.UA.IS_MEITUAN) {
              params = !isProd ? {
                olapeId: 496,
                layerId: 67,
                filterId: _uuid
              } : {
                olapeId: 52,
                layerId: 164,
                filterId: _uuid
              };
            }

            if (Drip.UA.IS_DIANPING) {
              params = !isProd ? {
                olapeId: 496,
                layerId: 68,
                filterId: _uuid
              } : {
                olapeId: 52,
                layerId: 165,
                filterId: _uuid
              };
            }

            return _context.abrupt("return", axios.get("".concat(ajaxPreUrl, "/getMatchedFeature"), {
              params: params
            }).then(function (_ref2) {
              var code = _ref2.code,
                  data = _ref2.data;
              if (code !== 200) return {};
              var abtest = 0;

              if (data === 107 || data === 109 || data === 350 || data === 352) {
                abtest = 1;
              }

              if (data === 108 || data === 110 || data === 351 || data === 353) {
                abtest = 2;
              }

              return {
                abtest: abtest
              };
            }).catch(function () {
              return {};
            }));

          case 10:
            return _context.abrupt("return", {});

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  function getABtest() {
    return _getABtest.apply(this, arguments);
  }

  return getABtest;
}();
/**
 * 获取演出的资源位
 * @param {string} positionIds 资源位的Id列表, eg: 1,2,3
 */

export function fetchMyShowPositions(_x) {
  return _fetchMyShowPositions.apply(this, arguments);
} // 获取猫眼的广告位

function _fetchMyShowPositions() {
  _fetchMyShowPositions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(positionIds) {
    var projectId,
        uuid,
        osName,
        params,
        _args4 = arguments;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            projectId = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : 0;
            _context4.next = 3;
            return Drip.getUuid();

          case 3:
            uuid = _context4.sent;

            if (Array.isArray(positionIds)) {
              positionIds = positionIds.join(',');
            }

            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2,
              positionIds: positionIds
            };
            projectId && (params.projectId = projectId);
            return _context4.abrupt("return", axios.get(API_GET_POSITION_DETAIL, {
              params: params
            }).then(function (_ref9) {
              var code = _ref9.code,
                  data = _ref9.data;
              if (code !== 200) return [];
              data = data || [];
              data.forEach(function (a) {
                var positionId = a.positionId;
                a.adVOList.forEach(function (ad) {
                  ad.positionId = positionId;
                });
                a.adVOList = formatPositionItem(a.adVOList);
              });
              return data;
            }).catch(function (err) {
              console.error(err.message);
              return [];
            }));

          case 9:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _fetchMyShowPositions.apply(this, arguments);
}

export function fetchMaoyanADList() {
  var _Drip$constant2 = Drip.constant,
      cityId = _Drip$constant2.cityId,
      userId = _Drip$constant2.userId,
      uuid = _Drip$constant2.uuid,
      appName = _Drip$constant2.uaInfo.appName;
  var _Drip$UA = Drip.UA,
      osName = _Drip$UA.osName,
      appVersion = _Drip$UA.appVersion;
  osName = ['ios', 'iphone', 'ipad', 'android', 'touch', 'wechat_small_program', 'windows'].includes(osName) ? osName : 'windows'; // clientType: 取值范围：ios,iphone,ipad,android,touch,wechat_small_program,windows
  // version_name(支持版本定投的广告位必填)

  var params = Object.assign({
    ci: cityId || 1,
    clientType: osName,
    version_name: appVersion
  }, maoyanAd);
  var adsUrl = isProd ? '//ad.maoyan.com/api/position/detail' : 'http://ad.movie.test.sankuai.com/api/position/detail';

  if (userId) {
    params.userid = userId;
  }

  if (uuid) {
    params.uuid = uuid;
  }

  return axios.get(adsUrl, {
    params: params
  }).then(function (_ref3) {
    var success = _ref3.success,
        data = _ref3.data;

    if (success && data && data.length > 0) {
      var list = data[0].config || [];

      var _ref4 = data[0] || {},
          positionId = _ref4.positionId;

      list.forEach(function (a) {
        a.positionId = positionId;
      });
      return formatPositionItem(list);
    }

    return [];
  }).catch(function (err) {
    if (err) console.error(err.message);
    return [];
  });
}
export function loadNewHome() {
  return _loadNewHome.apply(this, arguments);
}
/**
 * 演出资源位合并接口
 */

function _loadNewHome() {
  _loadNewHome = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", axios.get(API_GET_CONFIG).then(function (_ref10) {
              var code = _ref10.code,
                  data = _ref10.data;
              if (code !== 200) return false;

              try {
                var _Drip$constant3 = Drip.constant,
                    _Drip$constant3$cityI = _Drip$constant3.cityId,
                    _cityId = _Drip$constant3$cityI === void 0 ? 1 : _Drip$constant3$cityI,
                    sellChannel = _Drip$constant3.sellChannel;

                data = JSON.parse(data);

                if (data.allCity) {
                  // 全部城市都切换到新版的首页
                  return true;
                }

                var cityIdList = [];

                if (sellChannel === 1) {
                  // 点评cityId
                  cityIdList = data && data.dianCityIdList || [];
                } else {
                  // 美团cityId
                  cityIdList = data && data.meiIdList || [];
                }

                return cityIdList.includes(+_cityId);
              } catch (e) {
                return false;
              }
            }).catch(function () {
              return false;
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _loadNewHome.apply(this, arguments);
}

var needFormatKeys = ['middleBannerAds', 'recommendAds', 'goldenAds'];
export function fetchMyShowAds() {
  return _fetchMyShowAds.apply(this, arguments);
}
/**
 * 获取日历模块列表
 * @param {number} [pageNo=1] 页数
 * @param {number} [pageSize=1] 页数
 */

function _fetchMyShowAds() {
  _fetchMyShowAds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return Drip.getUuid();

          case 2:
            uuid = _context6.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2
            };
            return _context6.abrupt("return", axios.get(API_GET_AD_DETAIL, {
              params: params
            }).then(function (_ref11) {
              var code = _ref11.code,
                  data = _ref11.data;
              if (code !== 200) return {};
              data = data || {};
              needFormatKeys.forEach(function (key) {
                var adList = data[key];
                if (!adList) return;
                adList.forEach(function (ad) {
                  var positionId = ad.positionId;
                  ad.adVOList.forEach(function (ad) {
                    ad.positionId = positionId;
                  });
                  ad.adVOList = formatPositionItem(ad.adVOList);
                });
              });
              return data;
            }).catch(function (err) {
              console.error(err.message);
              return [];
            }));

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchMyShowAds.apply(this, arguments);
}

export function fetchCalendarList(_x2) {
  return _fetchCalendarList.apply(this, arguments);
}
/**
 * 获取品牌推荐列表
 */

function _fetchCalendarList() {
  _fetchCalendarList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref5) {
    var _ref5$pageNo, pageNo, _ref5$pageSize, pageSize, startDay, endDay, timeFilterType, uuid, osName, params, type, time;

    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _ref5$pageNo = _ref5.pageNo, pageNo = _ref5$pageNo === void 0 ? 1 : _ref5$pageNo, _ref5$pageSize = _ref5.pageSize, pageSize = _ref5$pageSize === void 0 ? 20 : _ref5$pageSize, startDay = _ref5.startDay, endDay = _ref5.endDay, timeFilterType = _ref5.timeFilterType;
            _context7.next = 3;
            return Drip.getUuid();

          case 3:
            uuid = _context7.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2
            };
            type = timeFilterType ? ";timeFilterType=".concat(timeFilterType) : '';
            time = startDay && endDay ? "?sd=".concat(startDay, "&ed=").concat(endDay) : "";
            return _context7.abrupt("return", axios.get("".concat(API_GET_CALENDAR_LIST, "/0;pageNo=").concat(pageNo, ";pageSize=").concat(pageSize, ";st=10").concat(type).concat(time), {
              params: params
            }).then(function (body) {
              body.data = defaultPosterUrl(body.data || []);
              return body;
            }).catch(function () {
              return {
                code: 500,
                data: []
              };
            }));

          case 9:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _fetchCalendarList.apply(this, arguments);
}

export function fetchBrandList() {
  return _fetchBrandList.apply(this, arguments);
}
/**
 * 查询品牌详情
 */

function _fetchBrandList() {
  _fetchBrandList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    var uuid, osName, params;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return Drip.getUuid();

          case 2:
            uuid = _context8.sent;
            osName = Drip.UA.osName;
            params = {
              uuid: uuid,
              clientType: osName === 'ios' ? 1 : 4,
              os: osName === 'ios' ? 1 : 2
            };
            return _context8.abrupt("return", axios.get(API_GET_BRAND_LIST, {
              params: params
            }).then(function (_ref12) {
              var code = _ref12.code,
                  data = _ref12.data;
              if (code !== 200) return [];
              return data || [];
            }).catch(function () {
              return [];
            }));

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchBrandList.apply(this, arguments);
}

export function fetchBrandDetail(brandId) {
  return axios.get("".concat(API_GET_BRAND_DETAIL, "/").concat(brandId)).then(function (body) {
    return body;
  }).catch(function () {
    return {
      code: 500,
      data: []
    };
  });
}
/**
 * 查询品牌项目
 */

export function fetchBrandProjectList(_ref6) {
  var brandId = _ref6.brandId,
      _ref6$pageNo = _ref6.pageNo,
      pageNo = _ref6$pageNo === void 0 ? 1 : _ref6$pageNo;
  return axios.get("".concat(API_GET_RECOMMEND_LIST, "/0;st=4;p=").concat(pageNo, ";s=20;tft=0?brandId=").concat(brandId)).then(function (body) {
    body.data = defaultPosterUrl(body.data || []);
    return body;
  }).catch(function () {
    return {
      code: 500,
      data: []
    };
  });
}